import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";

export default function CashPaymentModal({
  open,
  onOpenChange,
  total,
  cashReceived,
  onCashReceivedChange,
  change,
  processing,
  onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Pagamento em Dinheiro</DialogTitle>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <div className="text-center">
            <p className="text-sm text-gray-500">Total a pagar</p>
            <p className="text-3xl font-black text-emerald-600">€{total.toFixed(2)}</p>
          </div>
          <div>
            <label className="text-sm text-gray-500 block mb-1">Valor recebido</label>
            <Input
              type="number"
              step="0.01"
              placeholder="0.00"
              value={cashReceived}
              onChange={(e) => onCashReceivedChange(e.target.value)}
              className="h-14 text-2xl font-bold text-center"
              autoFocus
            />
          </div>
          {cashReceived && parseFloat(cashReceived) >= total && (
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 text-center">
              <p className="text-sm text-amber-600">Troco</p>
              <p className="text-3xl font-black text-amber-600">€{change.toFixed(2)}</p>
            </div>
          )}
          <div className="grid grid-cols-4 gap-2">
            {[5, 10, 20, 50].map((v) => (
              <Button
                key={v}
                variant="outline"
                className="h-12 font-bold"
                onClick={() => onCashReceivedChange(String(v))}
              >
                €{v}
              </Button>
            ))}
          </div>
          <Button
            className="w-full h-14 bg-emerald-600 hover:bg-emerald-700 font-bold text-lg"
            onClick={onConfirm}
            disabled={processing || !cashReceived || parseFloat(cashReceived) < total}
          >
            {processing ? (
              <Loader2 className="w-5 h-5 animate-spin" />
            ) : (
              "CONFIRMAR PAGAMENTO"
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
